import { isDefined, randomUUID } from '@aloft/toolkit-shared';
import { Document, Image } from '@react-pdf/renderer';

import { Page } from '../../../components/PdfExportV2/Page/Page.tsx';
import { Text } from '../../../components/PdfExportV2/Text/Text.tsx';
import { selectAllCommentaryData } from '../../../redux/features/selectors/commentarySelectors/selectAllCommentaryData.ts';
import { COMMENTARY_TEXT, PNG_HEIGHT, PNG_WIDTH } from '../consts.ts';
import { ExportChartContainer } from './ExportChartContainer.tsx';
import { ExportCommentarySection } from './ExportCommentarySection.tsx';
import { ExportCommentaryTable } from './ExportCommentaryTable.tsx';
import { convertComparableSalesDataToStringArray } from './convertComparableSalesDataToStringArray.ts';

export const ExportMarketAdjustments = ({
  data,
  subjectAddress,
  chartSrc,
}: {
  data: Pick<ReturnType<typeof selectAllCommentaryData>, 'marketAdjustments'>['marketAdjustments'];
  subjectAddress: string;
  chartSrc?: string;
}) => {
  if (!data) {
    return (
      <Document>
        <Page title="">
          <ExportCommentarySection
            subjectAddress={subjectAddress}
            {...COMMENTARY_TEXT['list-to-sale']}
          />
        </Page>
      </Document>
    );
  }

  const {
    commentary,
    comparableSalesDataTable,
    helperText,
    listToSaleMethod,
    listToSaleRatio,
    method,
    table,
  } = data;

  return (
    <Document>
      <Page title="">
        <ExportCommentarySection
          subjectAddress={subjectAddress}
          {...COMMENTARY_TEXT['list-to-sale']}
        >
          {chartSrc && (
            <ExportChartContainer
              title={method === 'zillow' ? 'Zillow Home Value Index' : 'Custom Home Value Index'}
            >
              <Image src={chartSrc} style={{ height: PNG_HEIGHT, width: PNG_WIDTH }} />
            </ExportChartContainer>
          )}

          {table.map(
            (t, index) =>
              t && (
                <ExportCommentaryTable
                  key={randomUUID()}
                  data={t.map((row) => row.map((cell) => cell.value)) as [string[], ...string[][]]}
                  helperText={
                    index === table.length - 1 && listToSaleMethod !== 'customRatio'
                      ? helperText
                      : undefined
                  }
                />
              ),
          )}
          {listToSaleMethod === 'customRatio' && (
            <>
              <Text variant="h3">{COMMENTARY_TEXT['list-to-sale'].headerText}</Text>
              <ExportCommentaryTable
                data={convertComparableSalesDataToStringArray(comparableSalesDataTable)}
              />
              <Text variant="h3">
                {`List to sale price adjustment: ${isDefined(listToSaleRatio) ? `${listToSaleRatio.toString()}%` : '-'}`}
              </Text>
              {helperText && <Text variant="tableHelperText">{helperText}</Text>}
            </>
          )}
          {commentary && (
            <>
              <Text variant="h4">Commentary</Text>
              <Text variant="body1">{commentary ?? ''}</Text>
            </>
          )}
        </ExportCommentarySection>
      </Page>
    </Document>
  );
};
